import styled, { css } from 'styled-components';
import { resetInput, align } from 'styled-manila';
import { getColor } from 'core/utils/Styles';

export const desktop = (...args) => css`
	@media (min-width: 1024px) {
		${css(...args)}
	}
`;

export const Wrapper = styled.div`
	font-size: 14px;
	position: relative;
	background-color: ${getColor('white')};
	transition: 0.3s;
	border-radius: 4px;

	${({ invalid, deskHeight }) => invalid && css`
		margin-bottom: ${deskHeight ? deskHeight : '54px'};
	`}
`;

/*
 * Label props:
 * top <bool> align top (default: vertical)
 */
export const Label = styled.label`
	${align('vertical')};
	line-height: 10px;
	left: 15px;
	color: ${getColor('gray8')};
	transition: 0.3s ease-in-out;
	font-weight: 400;
	margin: 0;

	${props => props.top && css`
		top: calc(1em + 10px);
	`};
`;

const inputPseudo = css`
	&:focus {
		border: 2px solid ${props => props.focusColor ? getColor(props.focusColor) : getColor('primaryBrand')};

		/* stylelint-disable  no-descending-specificity */
		& + label {
			color: ${props => props.focusColor ? getColor(props.focusColor) : getColor('dustyGray')};
		}
		/* stylelint-enable */
	}
`;

const flyLabel = (mobileY) => css`
	/* stylelint-disable  no-descending-specificity */
	&[required]:valid + label,
	&.valid + label,
	&:focus + label {
		transform: scale(0.9, 0.9) translateY(${mobileY});
		transition: 0.2s ease-in-out;
		left: 0;
		color: ${props => props.focusColor ? getColor(props.focusColor) : getColor('dustyGray')};
		${desktop`transform: scale(0.9, 0.9) translateY(-450%);`}
	}
	/* stylelint-enable */
`;

export const RatingInputRow = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-end;
`;

export const CloseWrapper = styled.div`
	margin-bottom: 5px;
	margin-right: 8px;
`;

const inputInvalid = (mobileY) => css`
	${props => props.invalid && css`
		border-color: ${getColor('salmon')};

		& + label {
			color: ${getColor('salmon')};
			transform: scale(0.9, 0.9) translateY(${mobileY});
			transition: 0.2s ease-in-out;
			left: 0;
			${desktop`transform: scale(0.9, 0.9) translateY(-450%);`}
		}
	`}
`;

/*
 * Input, Textarea props:
 * border <bool>
 * focusColor <string> e.g. "lavender"
 */
export const Input = styled.input`
	${resetInput}
	width: 100%;
	height: 40px;
	outline: none;
	margin: 0;
	padding: 10px 1em;
	resize: none;
	border: 1px solid ${props => props.border ? getColor('alto') : 'transparent'};
	border-radius: 4px;
	transition: 0.2s ease-in;

	${inputPseudo}
	${flyLabel('-360%')}
	${inputInvalid('-360%')}

	@media (min-width: 1024px) {
		height: ${({ deskHeight }) => deskHeight ? deskHeight : '54px'};
	}
`;

export const UndoWrapper = styled.div`
	color: ${getColor('primaryBrand')};
	cursor: pointer;
`;

export const Textarea = styled.textarea`
	${resetInput}
	width: 100%;
	min-height: 136px;
	outline: none;
	margin: 0;
	padding: 10px 1em;
	resize: vertical;
	border: 1px solid ${props => props.border ? getColor('alto') : 'transparent'};
	border-radius: 4px;
	transition: 0.2s ease-in;

	${desktop`min-height: 185px;`}

	${inputPseudo}
	${flyLabel('-450%')}
	${inputInvalid('-450%')}
`;

export const RatingInputWrapper = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	grid-gap: 0 8px;
	align-items: center;

	${desktop`
		grid-gap: 0 16px;
	`}
`;

export const HelpText = styled.span`
	color: ${getColor('dustyGray')};
	font-size: 14px;
	letter-spacing: 0.2px;
`;

const errorMsgText = css`
	font-size: 14px;
	font-weight: 600;
	color: ${getColor('salmon')};
`;

export const ErrorMsgText = styled.span`
	${errorMsgText}
`;

export const ErrorMsg = styled.span`
	position: absolute;
	left: 0;
	top: 100%;

	${errorMsgText}

	margin: 0;
	background-color: ${getColor('bridesmaid')};
	padding-top: 10px;
	padding-bottom: 10px;
	text-align: center;
	border-radius: ${props => props.show ? '0 0 4px 4px' : '4px'};
	transition: 0.3s;
	transform: ${props => props.show ? 'translateY(0)': 'translateY(-100%)'};
	z-index: ${props => props.show ? '0' : '-1'};

	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;
